'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Cross1Icon } from '@radix-ui/react-icons';
import { overlayStyles } from './Overlay.js';
import { panelStyles } from './Panel.js';
import { IconButton } from './IconButton.js';

const Dialog = DialogPrimitive.Root;
const DialogTrigger = DialogPrimitive.Trigger;
const StyledOverlay = styled(DialogPrimitive.Overlay, overlayStyles, {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
});
const StyledContent = styled(DialogPrimitive.Content, panelStyles, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 200,
    maxHeight: '85vh',
    padding: '$4',
    marginTop: '-5vh',
    // animation: `${fadeIn} 125ms linear, ${moveDown} 125ms cubic-bezier(0.22, 1, 0.36, 1)`,
    // Among other things, prevents text alignment inconsistencies when dialog can't be centered in the viewport evenly.
    // Affects animated and non-animated dialogs alike.
    willChange: 'transform',
    '&:focus': {
        outline: 'none',
    },
});
const StyledCloseButton = styled(DialogPrimitive.Close, {
    position: 'absolute',
    top: '$2',
    right: '$2',
});
const DialogContent = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(DialogPrimitive.Portal, null,
        React.createElement(StyledOverlay, null),
        React.createElement(StyledContent, Object.assign({}, props, { ref: forwardedRef }),
            children,
            React.createElement(StyledCloseButton, { asChild: true },
                React.createElement(IconButton, { variant: "ghost" },
                    React.createElement(Cross1Icon, null))))));
});
const DialogClose = DialogPrimitive.Close;
const DialogTitle = DialogPrimitive.Title;
const DialogDescription = DialogPrimitive.Description;

export { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle, DialogTrigger };
